import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-vertical-icon',
  templateUrl: './design-vertical.component.html'
})
export class DesignVerticalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
